__turbopack_context__.v({
  "avatar": "providerProfileCard-module-scss-module__oTsQMW__avatar",
  "avatarLink": "providerProfileCard-module-scss-module__oTsQMW__avatarLink",
  "avatarPlaceholder": "providerProfileCard-module-scss-module__oTsQMW__avatarPlaceholder",
  "card": "providerProfileCard-module-scss-module__oTsQMW__card",
  "compact": "providerProfileCard-module-scss-module__oTsQMW__compact",
  "full": "providerProfileCard-module-scss-module__oTsQMW__full",
  "info": "providerProfileCard-module-scss-module__oTsQMW__info",
  "location": "providerProfileCard-module-scss-module__oTsQMW__location",
  "meta": "providerProfileCard-module-scss-module__oTsQMW__meta",
  "name": "providerProfileCard-module-scss-module__oTsQMW__name",
  "nameLink": "providerProfileCard-module-scss-module__oTsQMW__nameLink",
  "rating": "providerProfileCard-module-scss-module__oTsQMW__rating",
  "reviewCount": "providerProfileCard-module-scss-module__oTsQMW__reviewCount",
  "star": "providerProfileCard-module-scss-module__oTsQMW__star",
  "verifiedBadge": "providerProfileCard-module-scss-module__oTsQMW__verifiedBadge",
  "yearsBreeding": "providerProfileCard-module-scss-module__oTsQMW__yearsBreeding",
});
